import { _ as r } from "../internals/export.js";
import { g as t } from "../internals/get-built-in.js";
import { f as n } from "../internals/function-apply.js";
import { f as i } from "../internals/function-call.js";
import { f as s } from "../internals/function-uncurry-this.js";
import { f as o } from "../internals/fails.js";
import { i as a } from "../internals/is-callable.js";
import { i as e } from "../internals/is-symbol.js";
import { a as u } from "../internals/array-slice.js";
import { g as f } from "../internals/get-json-replacer-function.js";
import { s as l } from "../internals/symbol-constructor-detection.js";
var m = String,
  c = t("JSON", "stringify"),
  p = s(/./.exec),
  j = s("".charAt),
  g = s("".charCodeAt),
  y = s("".replace),
  D = s(1..toString),
  F = /[\uD800-\uDFFF]/g,
  d = /^[\uD800-\uDBFF]$/,
  b = /^[\uDC00-\uDFFF]$/,
  v = !l || o(function () {
    var r = t("Symbol")();
    return "[null]" != c([r]) || "{}" != c({
      a: r
    }) || "{}" != c(Object(r));
  }),
  S = o(function () {
    return "\"\uDF06\uD834\"" !== c("\uDF06\uD834") || "\"\uDEAD\"" !== c("\uDEAD");
  }),
  h = function h(r, t) {
    var s = u(arguments),
      o = f(t);
    if (!(!a(o) && (void 0 === r || e(r)))) return s[1] = function (r, t) {
      if (a(o) && (t = i(o, this, m(r), t)), !e(t)) return t;
    }, n(c, null, s);
  },
  A = function A(r, t, n) {
    var i = j(n, t - 1),
      s = j(n, t + 1);
    return p(d, r) && !p(b, s) || p(b, r) && !p(d, i) ? "\\u" + D(g(r, 0), 16) : r;
  };
c && r({
  target: "JSON",
  stat: !0,
  arity: 3,
  forced: v || S
}, {
  stringify: function stringify(r, t, i) {
    var s = u(arguments),
      o = n(v ? h : c, null, s);
    return S && "string" == typeof o ? y(o, F, A) : o;
  }
});